"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.insertTableIntoTable = exports.areAllCellsSelected = exports.insertOverLayoutWidget = exports.flattenFragment = exports.insertIntoTableMiddleware = exports.insertLeadingWidget = exports.insertLeadingVoid = exports.insertAndOverride = exports.splitAndInsert = exports.insertIntoH2Placeholder = exports.maybeInsertLink = exports.maybeInsertLinkOverText = exports.insertAndAssume = exports.insertTextOverTableCells = void 0;
var TableNavigationActions_1 = require("Project/QwilrEditor/Behaviours/TableNavigationActions");
var Models_1 = require("ContentTokens/Models");
var lodash_1 = require("lodash");
var slate_1 = require("slate");
var EditorTypes_1 = require("../EditorTypes");
var TableColumnManager = __importStar(require("../Widgets/TableWidget/TableColumnManager"));
var TableActions = __importStar(require("./TableActions"));
var Utils_1 = require("../Utils");
var Variable_1 = require("ContentTokens/Models/Variable");
var WidgetActions_1 = require("./WidgetActions");
var Image_1 = require("ContentTokens/Models/Image");
var TokenModels_1 = __importDefault(require("ContentTokens/TokenModels"));
var QwilrEditorTelemetry_1 = require("../QwilrEditorTelemetry");
var lodash_2 = __importDefault(require("lodash"));
var TableActions_1 = require("./TableActions");
var SlateUtils_1 = require("./SlateUtils");
var MAX_COLUMNS = 20;
var insertTextOverTableCells = function (editor, fragment) {
    var startPoint = slate_1.Range.start(editor.selection);
    var tableEntry = (0, TableActions_1.getClosestTable)(editor, startPoint.path);
    if (!tableEntry) {
        return;
    }
    var _a = __read(tableEntry, 1), tableNode = _a[0];
    var selection = tableNode.data.selection;
    if (!selection) {
        return;
    }
    var selectedCells = selection.selectedCells;
    var flattenedText = fragment.map(function (f) { return slate_1.Node.string(f); }).join(" ");
    slate_1.Editor.withoutNormalizing(editor, function () {
        for (var i = 0; i < selectedCells.length; i++) {
            if (!selectedCells[i]) {
                continue;
            }
            var _a = __read((0, TableActions_1.getCellAtIndex)(i, tableEntry), 2), selectedCell = _a[0], pathToCell = _a[1];
            (0, SlateUtils_1.removeAllChildrenFromElement)([selectedCell, pathToCell], editor);
            var flattenedTextAsParagraph = TokenModels_1.default.paragraph.createSlateJson([
                TokenModels_1.default.text.createSlateJson(flattenedText, {}),
            ]);
            slate_1.Transforms.insertNodes(editor, flattenedTextAsParagraph, { at: __spreadArray(__spreadArray([], __read(pathToCell), false), [0], false) });
        }
    });
};
exports.insertTextOverTableCells = insertTextOverTableCells;
var insertAndAssume = function (editor, fragment) {
    if (!editor.selection) {
        return;
    }
    var existingEntry = (0, Utils_1.getClosestBlock)(editor, slate_1.Range.start(editor.selection).path);
    if (!existingEntry) {
        return;
    }
    slate_1.Editor.withoutNormalizing(editor, function () {
        if (lastBlockNotText(fragment) && !atEnd(editor)) {
            slate_1.Transforms.splitNodes(editor, { always: true });
            (0, Utils_1.moveToEndOfPreviousBlock)(editor);
        }
        slate_1.Transforms.splitNodes(editor, { always: true });
        slate_1.Transforms.insertFragment(editor, fragment, { voids: true });
        var pasted = (0, Utils_1.getNext)(editor, existingEntry[1], Utils_1.isBlockElement);
        if (!pasted) {
            return;
        }
        slate_1.Transforms.mergeNodes(editor, { at: pasted[1] });
    });
};
exports.insertAndAssume = insertAndAssume;
var extractLinkFromFragment = function (fragment) {
    if (fragment.length !== 1 || fragment[0].children.length !== 1) {
        return;
    }
    var text = fragment[0].children[0].text;
    try {
        new URL(text);
        return text;
    }
    catch (err) {
        return;
    }
};
var maybeInsertLinkOverText = function (editor, fragment, editorTelemetry) {
    var link = extractLinkFromFragment(fragment);
    if (!link) {
        return;
    }
    var _a = __read(slate_1.Editor.nodes(editor, {
        match: function (curr) {
            return curr.type === Models_1.InlineType.Link;
        },
    }), 1), existingLinkNodesInSelection = _a[0];
    if (!!existingLinkNodesInSelection) {
        slate_1.Transforms.unwrapNodes(editor, {
            match: function (curr) {
                return curr.type === Models_1.InlineType.Link;
            },
        });
    }
    var newLink = TokenModels_1.default.link.createSlateJson([], link);
    slate_1.Transforms.wrapNodes(editor, newLink, { split: true });
    lodash_2.default.defer(function () {
        slate_1.Transforms.setSelection(editor, { focus: editor.selection.anchor, anchor: editor.selection.focus });
    });
    editorTelemetry.hyperlinkURLAdded(link, QwilrEditorTelemetry_1.HyperlinkAddedSource.ExpandedSelectionPaste);
    return true;
};
exports.maybeInsertLinkOverText = maybeInsertLinkOverText;
var maybeInsertLink = function (editor, fragment, editorTelemetry) {
    var link = extractLinkFromFragment(fragment);
    if (!link) {
        return;
    }
    var linkFragment = [
        TokenModels_1.default.paragraph.createSlateJson([
            TokenModels_1.default.link.createSlateJson([TokenModels_1.default.text.createSlateJson(link, {})], link),
        ]),
    ];
    (0, exports.insertAndAssume)(editor, linkFragment);
    editorTelemetry.hyperlinkURLAdded(link, QwilrEditorTelemetry_1.HyperlinkAddedSource.CollapsedSelectionPaste);
    return true;
};
exports.maybeInsertLink = maybeInsertLink;
var insertIntoH2Placeholder = function (editor, fragment) {
    if (getFirstBlockType(fragment) === EditorTypes_1.BlockType.Heading1) {
        (0, exports.insertAndOverride)(editor, fragment);
    }
    else {
        (0, exports.insertAndAssume)(editor, fragment);
    }
};
exports.insertIntoH2Placeholder = insertIntoH2Placeholder;
var splitAndInsert = function (editor, fragment) {
    if (!editor.selection) {
        return;
    }
    slate_1.Transforms.splitNodes(editor, { always: true });
    var splitPointRef = slate_1.Editor.pathRef(editor, editor.selection.anchor.path);
    (0, exports.insertAndOverride)(editor, fragment);
    if (!lastBlockNotText(fragment) && !!splitPointRef.current) {
        var blockEntry = (0, Utils_1.getClosestBlock)(editor, splitPointRef.current);
        if (!blockEntry) {
            return;
        }
        slate_1.Transforms.setNodes(editor, getLastBlockProps(fragment), { at: blockEntry[1] });
    }
    splitPointRef.unref();
};
exports.splitAndInsert = splitAndInsert;
var insertAndOverride = function (editor, fragment, usingAdvancedTokens) {
    if (!editor.selection) {
        return;
    }
    var startPoint = slate_1.Range.start(editor.selection);
    var existingEntry = (0, Utils_1.getClosestBlock)(editor, startPoint.path);
    if (!existingEntry) {
        return;
    }
    if (!!usingAdvancedTokens && isVariableFragment(fragment) && (0, Image_1.isImageNode)(existingEntry[0])) {
        pasteVariableIntoImage(editor, existingEntry[1], fragment);
        return;
    }
    if (lastBlockNotText(fragment) && !atEnd(editor)) {
        slate_1.Transforms.splitNodes(editor, { always: true });
        (0, Utils_1.moveToEndOfPreviousBlock)(editor);
    }
    slate_1.Transforms.setNodes(editor, getFirstBlockProps(fragment), { at: existingEntry[1] });
    (0, exports.insertAndAssume)(editor, fragment);
};
exports.insertAndOverride = insertAndOverride;
var insertLeadingVoid = function (editor, fragment) {
    if (!atStart(editor)) {
        (0, exports.splitAndInsert)(editor, fragment);
    }
    else {
        (0, exports.insertAndOverride)(editor, fragment);
    }
};
exports.insertLeadingVoid = insertLeadingVoid;
var insertLeadingWidget = function (editor, fragment) {
    if (!editor.selection) {
        return;
    }
    var shouldMergeEnd = !atEnd(editor) && hasFragmentGotMergeableEnd(fragment);
    slate_1.Transforms.splitNodes(editor);
    var startPoint = slate_1.Range.start(editor.selection);
    var blockEntry = (0, Utils_1.getClosestBlock)(editor, startPoint.path);
    if (!blockEntry) {
        return;
    }
    var shouldReplaceBlock = slate_1.Node.string(blockEntry[0]) === "";
    var replaceBlockPath = slate_1.Editor.pathRef(editor, blockEntry[1]);
    var insertPointRef;
    var wasAtEndOfContent = false;
    if (atStart(editor) && !shouldReplaceBlock) {
        insertPointRef = slate_1.Editor.pointRef(editor, startPoint);
    }
    else {
        var nextText = (0, Utils_1.getNext)(editor, startPoint.path, slate_1.Text.isText);
        if (nextText) {
            insertPointRef = slate_1.Editor.pointRef(editor, { path: nextText[1], offset: 0 });
        }
        else {
            wasAtEndOfContent = true;
        }
    }
    slate_1.Transforms.insertNodes(editor, fragment);
    var lastInsertedBlock = insertPointRef && insertPointRef.current && (0, Utils_1.getPrevious)(editor, insertPointRef.current.path, Utils_1.isBlockElement);
    if (lastInsertedBlock) {
        slate_1.Transforms.select(editor, slate_1.Editor.end(editor, lastInsertedBlock[1]));
    }
    else if (wasAtEndOfContent) {
        slate_1.Transforms.select(editor, slate_1.Editor.end(editor, []));
    }
    if (shouldReplaceBlock && replaceBlockPath.current) {
        slate_1.Transforms.removeNodes(editor, { at: replaceBlockPath.current });
    }
    if (shouldMergeEnd) {
        var newStartPoint = slate_1.Range.start(editor.selection);
        var currBlock = (0, Utils_1.getClosestBlock)(editor, newStartPoint.path);
        if (currBlock && slate_1.Node.string(currBlock[0]) !== "") {
            var nextBlockEntry = (0, Utils_1.getNext)(editor, newStartPoint.path, Utils_1.isBlockElement);
            if (nextBlockEntry) {
                slate_1.Transforms.mergeNodes(editor, { at: nextBlockEntry[1] });
            }
        }
    }
    replaceBlockPath.unref();
    if (insertPointRef) {
        insertPointRef.unref();
    }
};
exports.insertLeadingWidget = insertLeadingWidget;
var insertIntoTableMiddleware = function (event, editor) {
    if (!editor.selection) {
        return;
    }
    var startPoint = slate_1.Range.start(editor.selection);
    var tableEntry = (0, TableNavigationActions_1.getTableFromCell)(editor, startPoint.path);
    if (!tableEntry) {
        return;
    }
    event.fragment = (0, exports.flattenFragment)(event.fragment);
    if (event.fragment.length) {
        event.data.leadingType = event.fragment[0].type;
    }
    var targetCellIndex = getTargetCellIndex(editor, tableEntry[0]);
    var targetCellEntry = TableActions.getCellAtIndex(targetCellIndex, tableEntry);
    var _a = __read(targetCellEntry, 2), currCell = _a[0], currCellPath = _a[1];
    if (slate_1.Path.equals(startPoint.path, currCellPath)) {
        var textNodes = Array.from(slate_1.Node.texts(currCell));
        var lastNode = textNodes[textNodes.length - 1];
        slate_1.Transforms.select(editor, { path: lastNode[1], offset: lastNode[0].text.length });
    }
};
exports.insertIntoTableMiddleware = insertIntoTableMiddleware;
var flattenFragment = function (fragment) {
    var fragmentEditor = (0, Utils_1.createConfiguredEditor)(fragment);
    var blocks = slate_1.Editor.nodes(fragmentEditor, {
        at: [],
        match: function (curr) {
            return ((0, Utils_1.isBlockElement)(curr) &&
                ![EditorTypes_1.BlockType.TableCell, EditorTypes_1.BlockType.Table, EditorTypes_1.BlockType.TableDummy, EditorTypes_1.BlockType.TableRow].includes(curr.type));
        },
    });
    var flatFragment = Array.from(blocks).map(function (curr) { return curr[0]; });
    return flatFragment;
};
exports.flattenFragment = flattenFragment;
var insertOverLayoutWidget = function (editor, fragment) {
    if (!editor.selection) {
        return;
    }
    var startPoint = slate_1.Range.start(editor.selection);
    var pathToLayoutWidget = [startPoint.path[0]];
    slate_1.Transforms.removeNodes(editor, { at: pathToLayoutWidget });
    var nextText = (0, Utils_1.getNext)(editor, editor.selection.anchor.path, slate_1.Text.isText);
    var cursorPoint = slate_1.Editor.pointRef(editor, slate_1.Editor.start(editor, nextText[1]));
    slate_1.Transforms.insertNodes(editor, fragment, {
        at: pathToLayoutWidget,
    });
    var previousText = (0, Utils_1.getPrevious)(editor, cursorPoint.unref().path, slate_1.Text.isText);
    slate_1.Transforms.select(editor, slate_1.Editor.end(editor, previousText[1]));
    return;
};
exports.insertOverLayoutWidget = insertOverLayoutWidget;
var areAllCellsSelected = function (editor) {
    if (!editor.selection) {
        return;
    }
    var selection = editor.selection;
    var tableEntry = (0, Utils_1.checkAncestors)(editor, slate_1.Range.start(selection).path, function (node) {
        return node.type === EditorTypes_1.BlockType.Table;
    });
    var _a = tableEntry[0].data.selection, anchorCell = _a.anchorCell, focusCell = _a.focusCell, selectedCells = _a.selectedCells;
    var cellCount = selectedCells.length - 1;
    var startToEnd = anchorCell == 0 && focusCell == cellCount;
    var endToStart = focusCell == 0 && anchorCell == cellCount;
    return startToEnd || endToStart;
};
exports.areAllCellsSelected = areAllCellsSelected;
var insertTableIntoTable = function (editor, fragment) {
    if (!editor.selection) {
        return;
    }
    var startPoint = slate_1.Range.start(editor.selection);
    var tableEntry = (0, TableNavigationActions_1.getTableFromCell)(editor, startPoint.path);
    if (!tableEntry) {
        return;
    }
    var tableData = tableEntry[0].data;
    var startCellIndex = getTargetCellIndex(editor, tableEntry[0]);
    var _a = __read(TableActions.getCellAtIndex(startCellIndex, tableEntry), 2), targetCellPath = _a[1];
    var _b = __read(targetCellPath, 3), targetStartRow = _b[1], targetStartColumn = _b[2];
    var incomingTable = fragment[0];
    var incomingTableData = incomingTable.data;
    var columnsToAdd = targetStartColumn + incomingTableData.columns - tableData.columns;
    var rowsToAdd = targetStartRow - 1 + incomingTableData.rows - tableData.rows;
    if (columnsToAdd > 0) {
        addTableColumns(editor, tableEntry, columnsToAdd);
    }
    if (rowsToAdd > 0) {
        addTableRows(editor, tableEntry, rowsToAdd);
    }
    var updatedTable = slate_1.Editor.node(editor, tableEntry[1]);
    startCellIndex = TableActions.getCellIndexFromCellPath(editor, targetCellPath);
    replaceTableDummy(editor, updatedTable, incomingTable.children[0]);
    (0, lodash_1.slice)(incomingTable.children, 1).forEach(function (row, rowIndex) {
        var currCellIndex = startCellIndex;
        row.children.forEach(function (sourceCell, colIndex) {
            if (colIndex + targetStartColumn >= MAX_COLUMNS) {
                return;
            }
            var _a = __read(TableActions.getCellAtIndex(currCellIndex, updatedTable), 2), targetCellPath = _a[1];
            replaceTableCell(editor, updatedTable, currCellIndex, sourceCell);
            var lastText = (0, Utils_1.getLastText)(slate_1.Editor.node(editor, targetCellPath));
            slate_1.Transforms.select(editor, { path: lastText[1], offset: lastText[0].text.length });
            currCellIndex++;
        });
        startCellIndex += updatedTable[0].data.columns;
    });
};
exports.insertTableIntoTable = insertTableIntoTable;
var replaceTableCell = function (editor, table, index, newNode) {
    var _a = __read(TableActions.getCellAtIndex(index, table), 2), path = _a[1];
    slate_1.Transforms.removeNodes(editor, { at: path });
    slate_1.Transforms.insertNodes(editor, newNode, { at: path });
};
var replaceTableDummy = function (editor, table, newNode) {
    var _a = __read(table, 2), tablePath = _a[1];
    var pathToDummy = __spreadArray(__spreadArray([], __read(tablePath), false), [0], false);
    slate_1.Transforms.removeNodes(editor, { at: pathToDummy });
    slate_1.Transforms.insertNodes(editor, newNode, { at: pathToDummy });
};
var addTableColumns = function (editor, table, columnsToAdd) {
    if (columnsToAdd < 0) {
        throw new Error("Trying to add negative columns");
    }
    var tableData = table[0].data;
    var columnBorders = tableData.columnBorders;
    var columns = tableData.columns;
    var targetColumns = Math.min(columns + columnsToAdd, MAX_COLUMNS);
    while (columns < targetColumns) {
        columnBorders = TableColumnManager.addColumn(columns + 1, columnBorders);
        columnBorders = TableColumnManager.normalizeColumnBorders(columns + 1, columnBorders);
        TableActions.addTableColumn(editor, table[1], columns, columnBorders);
        columns++;
    }
};
var addTableRows = function (editor, table, rowsToAdd) {
    if (rowsToAdd < 0) {
        throw new Error("Trying to add negative rows");
    }
    var tableData = table[0].data;
    var rows = tableData.rows;
    var targetRows = rows + rowsToAdd;
    while (rows < targetRows) {
        TableActions.addTableRow(editor, table[1], rows);
        rows++;
    }
};
var getTargetCellIndex = function (editor, table) {
    if (!editor.selection) {
        return -1;
    }
    var path = slate_1.Range.start(editor.selection).path;
    var isInDummy = !!(0, Utils_1.checkAncestors)(editor, path, function (curr) { return curr.type === EditorTypes_1.BlockType.TableDummy; });
    if (isInDummy) {
        var selection = table.data.selection;
        if (!selection) {
            return 0;
        }
        return Math.min(selection.anchorCell, selection.focusCell);
    }
    var _a = __read((0, Utils_1.checkAncestors)(editor, path, function (curr) { return curr.type === EditorTypes_1.BlockType.TableCell; }), 2), nearestCellPath = _a[1];
    var cellIndex = TableActions.getCellIndexFromCellPath(editor, nearestCellPath);
    return cellIndex;
};
var getFirstBlockProps = function (fragment) {
    return {
        type: fragment[0].type,
        data: fragment[0].data,
        isVoid: fragment[0].isVoid,
    };
};
var getLastBlockProps = function (fragment) {
    return {
        type: fragment[fragment.length - 1].type,
        data: fragment[fragment.length - 1].data,
        isVoid: fragment[fragment.length - 1].isVoid,
    };
};
var getFirstBlockType = function (fragment) {
    return fragment[0].type;
};
var lastBlockNotText = function (fragment) {
    var lastBlock = fragment[fragment.length - 1];
    return lastBlock.isVoid || lastBlock.type === EditorTypes_1.BlockType.Table;
};
var atEnd = function (editor) {
    if (!editor.selection) {
        return false;
    }
    var startPoint = slate_1.Range.start(editor.selection);
    var startBlockEntry = (0, Utils_1.getClosestBlock)(editor, startPoint.path);
    var endBlockEntry = (0, Utils_1.getClosestBlock)(editor, slate_1.Range.end(editor.selection).path);
    if (!startBlockEntry || !endBlockEntry) {
        return false;
    }
    if (startBlockEntry[0] !== endBlockEntry[0]) {
        return true;
    }
    var blockTextLength = slate_1.Node.string(startBlockEntry[0]).length;
    var adjustedOffset = (0, Utils_1.getOffsetFrom)(editor, startBlockEntry[1], startPoint.path) + startPoint.offset;
    return adjustedOffset === blockTextLength;
};
var atStart = function (editor) {
    if (!editor.selection) {
        return false;
    }
    var startPoint = slate_1.Range.start(editor.selection);
    var parentBlockEntry = (0, Utils_1.getClosestBlock)(editor, startPoint.path);
    if (!parentBlockEntry) {
        return false;
    }
    var offsetFromStart = (0, Utils_1.getOffsetFrom)(editor, parentBlockEntry[1], startPoint.path);
    return offsetFromStart == 0 && startPoint.offset == 0;
};
var hasFragmentGotMergeableEnd = function (fragment) {
    var lastNode = fragment[fragment.length - 1];
    return (!lastNode.isVoid &&
        lastNode.type !== EditorTypes_1.BlockType.Table &&
        lastNode.type !== EditorTypes_1.BlockType.SideBySide &&
        lastNode.type !== EditorTypes_1.BlockType.Accordion);
};
var isVariableFragment = function (fragment) {
    var singleParagraph = fragment.length === 1 && fragment[0].type === EditorTypes_1.BlockType.Paragraph;
    if (!singleParagraph) {
        return false;
    }
    var singleVariableChild = fragment[0].children.length === 1 && (0, Variable_1.isVariableNode)(fragment[0].children[0]);
    if (!singleVariableChild) {
        return false;
    }
    return true;
};
var pasteVariableIntoImage = function (editor, path, fragment) {
    var variable = fragment[0].children[0];
    (0, WidgetActions_1.updateImageWidget)(editor, path, {
        src: "",
        variable: { name: variable.data.variableName, label: variable.data.variableLabel },
    });
};
